// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Ymri","content":"styles_content__HQWTb","checkbox":"styles_checkbox__1n4TI","checkboxLabel":"styles_checkboxLabel__3Fq4u"};